module.exports = __webpack_public_path__ + "img/resources-375.545c5135.jpg";